const ESTATES_TYPE_ABBREVIATION = {
    VIVIENDA: 'V',
    GARAJE: 'G',
    TRASTERO: 'T'
};

const ESTATE_REGISRATION_TYPE = {
    DIR: 'DIR',
    ADDRESS: 'ADDRESS',
    CRU: 'CRU',
    REG: 'REG',
    REG_DATA: 'REG_DATA'
};

module.exports = {
    ESTATES_TYPE_ABBREVIATION,
    ESTATE_REGISRATION_TYPE
};
